import { Head, usePage } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { TestimonialForm, type TestimonialData } from "./TestimonialForm"
import type { PageProps } from "@/types/inertia"

type Props = PageProps & {
  testimonial: TestimonialData
}

export default function TestimonialsEdit() {
  const { props } = usePage<Props>()
  const { testimonial } = props

  return (
    <AdminShell>
      <Head title="Edit Testimonial">
        <meta name="description" content="Edit client testimonial." />
        <meta property="og:title" content="Edit Testimonial" />
        <meta property="og:description" content="Edit client testimonial." />
      </Head>
      <PageHeader title="Edit testimonial" description={testimonial.attribution} />
      <div className="mt-8 max-w-2xl">
        <TestimonialForm
          testimonial={testimonial}
          actionUrl={`/admin/testimonials/${testimonial.id}`}
          method="patch"
        />
      </div>
    </AdminShell>
  )
}
